import { TActions } from '../../../AppModulesWrapper';

import {
  PUBLISH_OFFER_START,
  PUBLISH_OFFER_SUCCESS,
  PUBLISH_OFFER_FAIL,
  SET_IS_SUBAGENT_NOT_ENOUGH_MONEY,
} from '../../actions/publishInfo';
import { RESET_STATE } from '../../actions/resetState';
import { IPublishInfoState, EPublishOfferStatus } from '../../types/reducers/publishInfo';
import { defaultState } from './defaultState';

export function publishInfo(state: IPublishInfoState = defaultState, action: TActions): IPublishInfoState {
  switch (action.type) {
    case PUBLISH_OFFER_START: {
      return {
        ...state,
        status: EPublishOfferStatus.pending,
        errorCode: null,
        errorMessage: null,
        errors: null,
      };
    }

    case PUBLISH_OFFER_SUCCESS: {
      return {
        ...state,
        status: EPublishOfferStatus.success,
      };
    }

    case PUBLISH_OFFER_FAIL: {
      return {
        ...defaultState,
        status: EPublishOfferStatus.fail,
        ...action.payload,
      };
    }

    case SET_IS_SUBAGENT_NOT_ENOUGH_MONEY: {
      return {
        ...state,
        isSubagentNotEnoughMoney: action.payload,
      };
    }

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
}
